import { combineReducers } from 'redux';
import actionTypes from './actionTypes';
import { teamFilterReducerFactories } from 'media-base-ui/redux/utils';

/* State shape
 {
     gamesState: {
        availableTeams: Array,
        selectedTeams: Array,
        teamsByDivision: Object
     }
 }
 */


const selectedTeamsReducer = teamFilterReducerFactories.selectedTeamsReducerFactory
                                (actionTypes.CHANGE_TEAM_SELECTION)
                                (actionTypes.CHANGE_DIVISION_SELECTION)
                                (actionTypes.CHANGE_CONFERENCE_SELECTION)
                                (actionTypes.CHANGE_ALL_SELECTION)
                                (actionTypes.SELECT_INDIVIDUAL_TEAM)
                                (actionTypes.HYDRATE_TEAM_FILTER);


const previousSeasonReducer = (state = null, action) => {
    const { payload } = action;

    if(action.type === actionTypes.CHANGE_PREVIOUS_SEASON_VALUE){
        return payload;
    }

    return state;
};

const isCalendarFilterHiddenReducer = (state = true, action) => {
    if (action.type === actionTypes.TOGGLE_CALENDAR_FILTER) {
        return !state;
    }

    return state;
};

const isTeamFilterHiddenReducer = (state = true, action) => {
    if (action.type === actionTypes.TOGGLE_TEAM_FILTER) {
        return !state;
    }

    return state;
};

const gameListPreparingToScrollReducer = (state = false, action) => {
    if (action.type === actionTypes.SET_GAME_LIST_PREPARING_TO_SCROLL) {
        return action.payload.preparingToScroll
    }

    return state;
};

const gamesStateReducer = combineReducers({
    selectedTeams: selectedTeamsReducer,
    previousSeason: previousSeasonReducer,
    gameListPreparingToScroll: gameListPreparingToScrollReducer
});

const calendarFilterStateReducer = combineReducers({
    isCalendarListHidden: isCalendarFilterHiddenReducer
});

const teamFilterStateReducer = combineReducers({
    isTeamsListHidden: isTeamFilterHiddenReducer
});

const reducer =  combineReducers({
    gamesState: gamesStateReducer,
    calendarListState: calendarFilterStateReducer,
    teamsListState: teamFilterStateReducer
});

export default reducer;
